<glxy-page>
  <glxy-page-toolbar>
    <glxy-page-title>
      {{ 'NAVIGATION.TABS.PHP_LOGS' | translate }}
    </glxy-page-title>
    <glxy-page-actions>
      <button mat-flat-button color="primary" (click)="refreshLogs()">
        <mat-icon>refresh</mat-icon>
        {{ 'PAGES.PHP_LOGS.REFRESH' | translate }}
      </button>
      <a class="toolbar-help-button" mat-icon-button target="_blank" href="https://websitepro.zendesk.com/hc/en-us">
        <mat-icon>help_outline</mat-icon>
      </a>
    </glxy-page-actions>
  </glxy-page-toolbar>

  <glxy-page-wrapper>
    <div class="error-list-container">
      <va-filter2>
        <va-filter-toolbar>
          <va-search-box (update)="dataSource.updateSearchTerm($event)"></va-search-box>
          <mat-button-toggle-group (change)="toggleStaging($event)">
            <mat-button-toggle [checked]="true" value="production">
              {{ 'PAGES.PHP_LOGS.TOGGLE_BUTTON.PRODUCTION' | translate }}
            </mat-button-toggle>
            <mat-button-toggle value="staging">
              {{ 'PAGES.PHP_LOGS.TOGGLE_BUTTON.STAGING' | translate }}
            </mat-button-toggle>
          </mat-button-toggle-group>
        </va-filter-toolbar>
        <va-filter-content>
          <mat-table [dataSource]="dataSource">
            <ng-container matColumnDef="log">
              <mat-header-cell *matHeaderCellDef class="error-log-column-header">
                <div class="timestamp-header">{{ 'PAGES.PHP_LOGS.TABLE.HEADERS.TIMESTAMP' | translate }}</div>
                {{ 'PAGES.PHP_LOGS.TABLE.HEADERS.LOG' | translate }}
              </mat-header-cell>
              <mat-cell *matCellDef="let errorLog" class="error-log-column cell">
                <mat-expansion-panel>
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      {{ errorLog.timestamp | date: 'medium' }}
                    </mat-panel-title>
                    <mat-panel-description>
                      {{ errorLog.log }}
                    </mat-panel-description>
                  </mat-expansion-panel-header>
                  <p>{{ errorLog.log }}</p>
                  @if (isAnalyzing === true && errorLog.timestampString === analyzingLog) {
                    <mat-spinner class="total-table-spinner" color="accent" mode="indeterminate"></mat-spinner>
                  }
                  <p>
                    @for (summary of logSummaries; track summary) {
                      @if (summary.id === errorLog.timestampString) {
                        <strong>
                          <p class="ai-log" [innerHtml]="summary.summary"></p>
                        </strong>
                      }
                    }
                  </p>
                  <button mat-raised-button (click)="downloadLog(errorLog.timestampString)">
                    {{ 'PAGES.PHP_LOGS.TABLE.DOWNLOAD_LOG' | translate }}
                  </button>
                  &nbsp;
                  <button mat-raised-button (click)="analyzeLogs(errorLog.timestampString, errorLog.log)">
                    <span class="analyze-log-button-icon">
                      <img
                        src="https://vstatic-prod.apigateway.co/wsp-portal-client.9223372035065793860.demo/assets/images/ai-light-bulb-icon.svg"
                        alt="analyze-log"
                        />
                    </span>
                    {{ 'PAGES.PHP_LOGS.TABLE.ANALYZE_LOG' | translate }}
                  </button>
                </mat-expansion-panel>
              </mat-cell>
            </ng-container>
            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
          </mat-table>
          @if ((dataSource.loading$ | async) === true) {
            <mat-spinner class="total-table-spinner" color="accent" mode="indeterminate"></mat-spinner>
          } @else {
            @if ((dataSource.logsCount$ | async) === 0) {
              <div class="no-logs">
                <img [src]="noLogsUrl | async" alt="log" />
                <p>
                  <span class="title">
                    {{ 'PAGES.PHP_LOGS.NO_LOGS.TITLE' | translate }}
                  </span>
                  <br />
                  <span class="subtitle">
                    {{ 'PAGES.PHP_LOGS.NO_LOGS.SUBTITLE' | translate }}
                  </span>
                </p>
              </div>
            }
          }


          <mat-paginator
            #paginator
            (page)="dataSource.updatePageOptions($event)"
            [pageSizeOptions]="[10, 25, 50, 100]"
            [pageSize]="10"
            [length]="dataSource.logsCount"
            [showFirstLastButtons]="false"
            id="paginator-list"
          ></mat-paginator>
        </va-filter-content>
      </va-filter2>
    </div>
  </glxy-page-wrapper>
  <a #downloadAnchor [hidden]="true"></a>
</glxy-page>
